import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('basic-modal', () => import(/* webpackMode: "lazy" */'./basic-modal'));
